import Vue from "@/main";
import { Message } from "element-ui";

export let map; // mars3d.Map三维地图对象
let graphicLayer; // 矢量图层对象
let graphicLayer2; // 矢量漫游图层对象

let positions = []; //
let positionsObj = []; //

let savePaths = []; // 路径

// graphicLayer.getGraphics();  获取图层所有的矢量数据
// graphicLayer.removeGraphic();  移除Graphic矢量数据

// this.graphicLayer.on(mars3d.EventType.click, function (event) {
//     console.log("监听layer，单击了矢量对象", event)
// })

// this.graphicLayer.on(mars3d.EventType.rightClick, function (event){
//     console.log("监听layer，右键了矢量对象")
// }, this);

let fixedRoute;
let indexs = 1;

//汽车模型 gltf
let automobileList = [
  {
    url: "kache1.gltf",
  },
  {
    url: "jiaobanche.glb",
  },
  {
    url: "benchi1.gltf",
  },
  {
    url: "red_car.gltf",
  },
  {
    url: "suv.gltf",
  },
  // {
  //   url: "kache3.gltf",
  // },
  // {
  //   url: "bus2.gltf",
  // },
  // {
  //   url: "zhatuche.glb",
  // },
  // {
  //   url: "xiaofangche.gltf",
  // }
];
let speeds = [50, 60];

//车牌号所在地区
let citys = [
  "京",
  "津",
  "晋",
  "湘",
  "赣",
  "沪",
  "渝",
  "冀",
  "台",
  "辽",
  "吉",
  "黑",
  "苏",
  "浙",
  "皖",
  "闽",
  "鲁",
  "豫",
  "鄂",
  "青",
  "粤",
  "琼",
  "川",
  "贵",
  "云",
  "陕",
  "甘",
  "藏",
  "桂",
  "蒙",
  "宁",
  "新",
  "港",
  "澳",
];
//车牌号所在地区
let area = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
];
//车牌号后5位
let nums = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];

graphicLayer = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer);

graphicLayer2 = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer2);

bindLayerContextMenu(graphicLayer);
bindLayerContextMenu(graphicLayer2);

// 地图选点
export function setPoint() {
  // mars3d.Lang["_单击完成绘制"][0] = "双击完成绘制，右键取消绘制";
  graphicLayer.startDraw({
    type: "point",
    style: {
      color: "#00ffff",
      pixelSize: 5,
      outlineColor: "#ffffff",
      outlineWidth: 2,
      visibleDepth: false, //是否被遮挡
      label: {
        // 不需要文字时，去掉label配置即可
        text: indexs.toString(),
        font_size: 20,
        color: "#ffffff",
        outline: true,
        outlineColor: "#000000",
        pixelOffsetY: -20,
      },
    },
    addHeight: 100,
    success: (graphic) => {
      let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
        graphic._position_draw
      );
      // alt 高度（单位：米） lat 纬度  lng 经度
      positions.push([_lng, _lat, _alt]);
      positionsObj.push({
        lng: _lng,
        lat: _lat,
        alt: _alt,
        // datatime: "2021/11/3 00:00:" + this.initialTime
      });
      indexs += 1;
      // this.initialTime += 5

      // var text2 = parseInt(text)
      // this.setPoint(text2 += 1)
      // this.setRoute()
    },
  });
}

function setRoute() {
  // 添加行车路线
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: this.positions,
    style: {
      width: 6,
      color: "#ffff00",
    },
    attr: { remark: "示例16" },
    clampToGround: true,
  });
  this.graphicLayer.addGraphic(graphic);
}

//保存路线
export function savePath() {
  if (positions.length) {
    // if(positionsObj.length){
    savePaths.push(positions);
    // savePaths.push(this.positionsObj)
    Message({
      message: "恭喜你，这是一条成功消息",
      type: "success",
    });
    positions = [];
    positionsObj = [];

    indexs = 1;
    graphicLayer.clear();
    // this.$GLOBAL.map.removeLayer(this.graphicLayer)
    // this.graphicLayer.endDraw()
  } else {
    Message({
      message: "请先在地图选点",
      type: "warning",
    });
  }
}

//播放
export function drive() {
  let basePathUrl = window.basePathUrl || "";
  console.log("漫游", savePaths);
  savePaths.forEach((el, i) => {
    //     // 漫游方法
    let model = setAutomobileModel();
    let obj = {
      // id: model.id,
      // name: model.name,
      model: model.model,
      positions: el,
      frameRate: 1,
      speed: i % 2 == 0 ? speeds[0] : speeds[1], //轨迹的 速度( 单位：千米/小时)
      // timeField: "datatime",
      // autoStop: true, // 到达终点自动停止
      clockLoop: true, // 循环播放
      interpolation: true,
      pauseTime: 0, //每个点的停留时长（单位：秒）
      camera: {
        // type: "sd",
      },
    };
    fixedRoute = new mars3d.graphic.FixedRoute(obj);
    graphicLayer2.addGraphic(fixedRoute);
    fixedRoute.start();
  });
}

export function suspendFun() {
  //暂停
  fixedRoute.pause();
}
export function continueFun() {
  //继续
  fixedRoute.proceed();
}
export function reset() {
  // 重置
  graphicLayer.clear();
  graphicLayer2.clear();
  positions = [];
  positionsObj = [];
  savePaths = [];
}
//通用汽车模型数据
function setAutomobileModel() {
  let basePathUrl = window.basePathUrl || "";

  // let id = createLicencePlate()
  return {
    // id: id,
    // name: id,
    model: {
      url:
        basePathUrl +
        "gltf/cart/" +
        automobileList[generateRandomInteger(0, automobileList.length - 1)].url,
      scale: 1,
      minimumPixelSize: 1,
      mergeOrientation: true,
    },
  };
}

function bindLayerContextMenu(graphicLayer) {
  graphicLayer.bindContextMenu([
    {
      text: "删除对象",
      icon: "fa fa-trash-o",
      show: (event) => {
        const graphic = event.graphic;
        if (!graphic || graphic.isDestroy) {
          return false;
        } else {
          return true;
        }
      },
      callback: (e) => {
        const graphic = e.graphic;
        if (!graphic) {
          return;
        }
        const parent = graphic.parent; // 右击是编辑点时
        graphicLayer.removeGraphic(graphic);
        if (parent) {
          graphicLayer.removeGraphic(parent);
        }
      },
    },
  ]);
}

export function init() {
  positions = [];
  positionsObj = [];
  savePaths = [];
  graphicLayer = null;
  graphicLayer2 = null;
}

function generateRandomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function createLicencePlate() {
  return getcity() + getarea() + getend5(5);
}

//省份生成
function getcity() {
  var id = Math.floor(Math.random() * 34);
  return citys[id];
}
//地区生成
function getarea() {
  var id = Math.floor(Math.random() * 17);
  return area[id];
}
//车牌后五位
function getend5(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    var id = Math.floor(Math.random() * 36);
    res += nums[id];
  }
  return res;
}
